<div class="row">
  <inspection-new
    [processing]="processing"
    (toggleSaveInspection)="saveInspection($event)"
    (toggleCancel)="cancel()"
  ></inspection-new>
</div>
